module.exports = __webpack_public_path__ + "img/spacial-student1.453884d2.png";